import { Card, Table } from "@fpsoftware/mvp";
import { useBorrowerList, useSuspenseBorrower } from "@/borrower/hooks";
import { NoContent } from "@/common/NoContent";
import { Container } from "@/components/grid/Container";
import { Grid } from "@/components/grid/Grid";
import { AppPage } from "@/layout/AppLayout";

export const PageListBorrowers = () => {
  const clients = useBorrowerList();
  return (
    <AppPage title="Borrowers">
      <Container>
        <Grid className="mb-3">
          <Grid.Col xs={12}>
            <Card>
              <Card.Header>Borrowers</Card.Header>
              <Table>
                <Table.Head>
                  <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>Name</Table.HeaderCell>
                    <Table.HeaderCell>Email</Table.HeaderCell>
                  </Table.Row>
                </Table.Head>
                <Table.Body>
                  {clients.map((x) => (
                    <ClientRow key={x} ID={x} />
                  ))}
                  {clients.length === 0 && (
                    <Table.Row>
                      <Table.Cell colSpan={3}>
                        <NoContent
                          label="No borrowers added"
                          sublabel="You can add a new one when creating a new RFQ"
                          image="/select-option.svg"
                        />
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Table.Body>
              </Table>
            </Card>
          </Grid.Col>
        </Grid>
      </Container>
    </AppPage>
  );
};

function ClientRow(props: { ID: number }) {
  const client = useSuspenseBorrower(props.ID);
  return (
    <Table.Row>
      <Table.Cell>{client.ID}</Table.Cell>
      <Table.Cell>
        {client.firstName} {client.lastName}
      </Table.Cell>
      <Table.Cell>{client.email}</Table.Cell>
    </Table.Row>
  );
}
